import * as R from 'ramda';
export const rejectEmptyString = R.reject(R.equals(''));
